import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { IPDashboardPage, IPDetailPage } from '../components'

export const IPRouter = () => {
  const permissions = useSelector((state) => state.global.permissions)

  return (
    <Routes>
      <Route path="/" element={<IPDashboardPage />} />
      {permissions.ver_detalle_ip ? <Route path=":ipId" element={<IPDetailPage />} /> : null}
      <Route path="*" element={<Navigate to="/ip" />} />
    </Routes>
  )
}
